import React, { useEffect, useMemo, useRef, useState } from 'react';
import { FaXmark } from 'react-icons/fa6';
import './TutorialVideoModal.css';

// The tutorial video is served from a static URL (e.g. Firebase Storage
// download URL) — set REACT_APP_TUTORIAL_VIDEO_URL to enable it.
const TUTORIAL_VIDEO_URL = process.env.REACT_APP_TUTORIAL_VIDEO_URL || '';

const TutorialVideoModal = ({ isOpen, onClose }) => {
  const closeButtonRef = useRef(null);
  const [playbackError, setPlaybackError] = useState(null);

  const isLoading = false;
  const videoUrl = TUTORIAL_VIDEO_URL;
  const error = TUTORIAL_VIDEO_URL
    ? null
    : 'The tutorial video is not configured (set REACT_APP_TUTORIAL_VIDEO_URL).';

  const titleId = useMemo(() => 'tutorial-video-title', []);

  useEffect(() => {
    if (isOpen) setPlaybackError(null);
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return;

    const button = closeButtonRef.current;
    if (button && typeof button.focus === 'function') {
      button.focus();
    }
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return;

    const onKeyDown = (e) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        onClose();
      }
    };

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="tutorial-modal-overlay" role="presentation" onClick={onClose}>
      <div
        className="tutorial-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="tutorial-modal-header">
          <h2 className="tutorial-modal-title" id={titleId}>
            Tutorial: How to get the FrameworkAI browser extension
          </h2>
          <button
            type="button"
            className="tutorial-modal-close"
            onClick={onClose}
            aria-label="Close tutorial"
            ref={closeButtonRef}
          >
            <FaXmark />
          </button>
        </div>

        <div className="tutorial-modal-body">
          {isLoading && <div className="tutorial-modal-status">Loading video…</div>}
          {!isLoading && error && (
            <div className="tutorial-modal-error" role="alert">
              {error}
            </div>
          )}
          {!isLoading && !error && playbackError && (
            <div className="tutorial-modal-error" role="alert">
              {playbackError}
            </div>
          )}
          {!isLoading && !error && !playbackError && videoUrl && (
            <video
              className="tutorial-modal-video"
              controls
              autoPlay
              playsInline
              onError={() => {
                setPlaybackError(
                  'The tutorial video could not be loaded. Check that REACT_APP_TUTORIAL_VIDEO_URL points to a publicly readable MP4 (H.264/AAC).'
                );
              }}
            >
              <source src={videoUrl} type="video/mp4" />
            </video>
          )}
        </div>
      </div>
    </div>
  );
};

export default TutorialVideoModal;

